var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2588_14100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0.0245039 63.6336 18.3664 81.9755 41 82ZM37.5834 20.5C37.5834 18.613 39.113 17.0834 41 17.0834C42.887 17.0834 44.4166 18.613 44.4166 20.5V47.8334C44.4166 49.7203 42.887 51.25 41 51.25C39.113 51.25 37.5834 49.7203 37.5834 47.8334V20.5ZM41 61.5C42.887 61.5 44.4166 63.0297 44.4166 64.9166C44.4166 66.8036 42.887 68.3332 41 68.3332C39.113 68.3332 37.5834 66.8036 37.5834 64.9166C37.5834 63.0297 39.113 61.5 41 61.5Z",
    fill: "#FF5145"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2588_14100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.efe90efb43b60cb513ab864485de4fc9.svg";
export { ForwardRef as ReactComponent };